export enum ComingSoonProduct {
  ClassResolution = 'classresolution',
  DeepValidation = 'deepvalidation',
}
